import { BarTone } from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/getBarTone';

const getArchivedBarTone = (threshold: number | null): BarTone =>
  threshold === null ? BarTone.NoThreshold : BarTone.ArchivedPlan;

export default getArchivedBarTone;
